import script from "./ReserveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReserveModal.vue?vue&type=script&setup=true&lang=js"

import "./ReserveModal.vue?vue&type=style&index=0&id=16d21532&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16d21532"]])

export default __exports__